<template>
	<div class="report-wrap">
		<div class="report-box" ref="middle">
			<p class="title">
				<img src="@/assets/images/m-report/notice.png" alt="" />
				<span>上传须知</span>
			</p>
			<div class="upload-desc upload-group">
				<p class="h-red">
					* &nbsp;&nbsp;为了确保健康信息准确性，仅支持上传<b
						style="font-size: 16px; font-weight: bold"
						>本人</b
					>体检报告。
				</p>
				<p class="h1">上传格式支持：</p>
				<p>JPG、PNG、PDF；图片和PDF文件，仅可上传一种。</p>
				<p class="h1">图片拍摄要求：<span>（仅限一份报告）</span></p>
				<p><span>1、</span>保证充足光线；</p>
				<p><span>2、</span>保证正面拍摄、不可侧拍；</p>
				<p><span>3、</span>不可斜拍（超过倾斜角度15°）、不可倒拍；</p>
				<p>
					<span>4、</span
					>保证所需资料内容至少占整张图片的二分之一以上；
				</p>
				<p><span>5、</span>保证资料内容文字清晰可读、不模糊；</p>
				<p>
					<span>6、</span>保证拍摄资料的背景干净，无其他文字干扰，如资
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;料不可放在报纸上拍摄；
				</p>
				<p class="h-red">* &nbsp;&nbsp;PDF文件仅限上传一份</p>
			</div>
			<div class="upload-group">
				<p class="upload-label">* &nbsp;&nbsp;填写报告机构</p>
				<input
					maxlength="20"
					class="upload-form upload-item"
					v-model="form.reportOrg"
					placeholder="请输入对应的体检机构"
					type="text"
				/>
				<p class="upload-label">
					* &nbsp;&nbsp;上传报告 <span>（请选择一种上传方式）</span>
				</p>
				<div
					class="upload-item"
					@click="toUploadFile(2)"
					:class="{ disabled: uploadType == 1 && form.pdfFile }"
				>
					<span>拍照/相册上传</span>
					<img
						src="@/assets/images/m-report/arrow-right.png"
						class="right-icon"
					/>
				</div>
				<Upload
					v-if="uploadType == 2"
					:params="params"
					:accept="accept"
					@receive="getReceive"
				/>
				<div
					class="upload-item"
					@click="toUploadFile(1)"
					:class="{
						disabled: uploadType == 2 && form.picList.length > 0,
					}"
				>
					<span>上传PDF</span>
					<img
						src="@/assets/images/m-report/arrow-right.png"
						class="right-icon"
					/>
				</div>
				<div></div>
				<Upload
					v-if="uploadType == 1"
					:params="params"
					:accept="accept"
					@receive="getReceive"
				/>
			</div>
		</div>

		<div class="submit-btn">
			<button
				class="btn"
				@click="submitForm"
				:disabled="disabled || loading"
				:class="{ disabled: disabled }"
			>
				{{ submitText }}
			</button>
		</div>
		<Popup ref="reportPopup" :content="tipData" @confrim="confirmPop" />
	</div>
</template>
<script type="text/javascript">
	import Upload from "./Upload.vue";
	import Popup from "./popup.vue";
	import { mapGetters } from "vuex";
	import { Toast } from "vant";
	import Axios from "axios";
	export default {
		name: "UserReport",
		data() {
			return {
				form: {
					reportOrg: "",
					pdfFile: null,
					picList: [],
					fileType: 0,
				},
				tipData: {},
				hasValue: 0,
				loading: false,
				uploadType: 0, //上传类型 1pdf 2图片
				submitText: "确认上传",
			};
		},
		components: {
			Upload,
			Popup,
		},
		computed: {
			...mapGetters(["userData"]),
			params() {
				return this.uploadType == 1
					? {
							key: "pdfFile",
							size: 10,
							limitCount: 1,
							uploadType: 1,
							type: ["pdf"],
					  }
					: {
							key: "picList",
							size: 10,
							limitCount: 20,
							uploadType: 2,
							type: ["jpg", "jpeg", "png"],
					  };
			},
			accept() {
				return this.uploadType == 1
					? "application/pdf"
					: "image/png,image/jpeg,image/jpg";
			},
			disabled() {
				if (!this.uploadType) return true;
				else if (
					(!this.form.pdfFile || !this.form.reportOrg) &&
					this.uploadType == 1
				)
					return true;
				else if (
					(this.form.picList.length == 0 || !this.form.reportOrg) &&
					this.uploadType == 2
				)
					return true;
				else return false;
			},
		},
		methods: {
			getReceive(data) {
				console.log(data);
				this.form[data.key] = data.value;
			},
			confirmPop() {
				if (this.tipData.state == 1) {
					this.$router.push({
						path: "/user/body-report/list",
					});
				}
			},
			// 选择图片/pdf上传，下拉至底部
			toUploadFile(type) {
				if (
					this.uploadType &&
					(this.form.pdfFile || this.form.picList.length > 0)
				)
					return;
				this.uploadType = type;
				this.form.fileType = type;
				this.$nextTick(() => {
					let middle = this.$refs["middle"];
					middle.scrollTop = middle.scrollHeight;
				});
			},
			// 表单数据格式化
			processData() {
				var json = new FormData();
				for (var i in this.form) {
					if (Array.isArray(this.form[i]) && this.form[i].length > 0) {
						this.form[i].forEach((value, index) => {
							json.append(`picFiles`, value.picFile);
						});
					} else {
						json.append(i, this.form[i]);
					}
				}
				return json;
			},
			// 提交信息，校验信息
			submitForm() {
				if (!this.form.reportOrg) {
					Toast("请选择报告机构");
					return;
				}
				if (this.uploadType == 1) {
					if (!this.form.pdfFile) {
						Toast("请选择文件");
						return;
					}
				} else {
					if (this.form.picList.length == 0) {
						Toast("请选择图片");
						return;
					}
				}
				this.submitText = "上传中";
				if (this.flag) return;
				this.flag = true;
				console.log(this.userData);
				let form = Object.assign(this.form, this.userData);
				let params = this.processData(form);
				Axios.post(this.getApiUrl("reportUpload"), params, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
					.then((res) => {
						if (res.data.code == 1) {
							this.tipData = {
								state: 1,
								msg: "您的体检资料已上传成功!我们将通过通知消息反馈解析结果。<br/>敬请关注！谢谢！",
								icon: require("@/assets/images/m-report/success-icon.png"),
							};
						} else {
							this.tipData = {
								state: 2,
								msg: "很抱歉！资料上传失败！请您确认文件格式、大小，修改后再次上传。谢谢",
								icon: require("@/assets/images/m-report/fail-icon.png"),
							};
						}
						this.$refs.reportPopup.show = true;
						this.flag = false;
						this.submitText = "确认上传";
					})
					.catch((err) => {
						this.flag = false;
						this.submitText = "确认上传";
						Toast(err.msg);
					});
			},
		},
		created() {
			// 设置页面title
			document.title = "体检报告上传";
			if (this.$route.query.fromDetail) {
				let reportData =
					JSON.parse(localStorage.getItem("reportData")) || {};
				this.form.reportOrg = reportData.originalName; // 重新上传回传机构名称
			}
			console.log(this.userData);
		},
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/function.scss";

	.report-wrap {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #f7f7f7;
		.report-box {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: getsize(200px);
			padding: getsize(40px) getsize(20px) getsize(40px);
			overflow-y: scroll;
			-webkit-overflow-scrolling: touch;
			z-index: 1;
		}
		.title {
			display: flex;
			height: getsize(60px);
			margin-bottom: getsize(33px);
			align-items: center;
			img {
				width: getsize(60px);
				height: getsize(60px);
			}
			span {
				margin-left: getsize(20px);
				font-weight: bold;
				color: #333333;
				font-size: getsize(34px);
			}
		}
		.upload-group {
			width: 100%;
			box-sizing: border-box;
			padding: getsize(40px) getsize(20px) getsize(27px);
			background-color: #ffffff;
			box-shadow: 0px 0px getsize(16px) 0px rgba(220, 220, 220, 0.3);
			border-radius: getsize(20px);
			.upload-label {
				font-size: getsize(30px);
				font-weight: bold;
				color: #f77054;
				margin-bottom: getsize(17px);
				span {
					color: #666666;
					font-weight: normal;
				}
			}
			.upload-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				box-sizing: border-box;
				height: getsize(88px);
				background: #ffffff;
				border-radius: getsize(20px);
				border: getsize(1px) solid #bcbcbc;
				padding: 0 getsize(32px);
				margin-bottom: getsize(20px);
				font-size: getsize(28px);
				color: #666666;
				&.disabled {
					background: #f7f7f7;
					border: none;
					color: #bcbcbc;
				}
				&.upload-form {
					padding: getsize(24px) getsize(32px);
					line-height: normal;
					height: 100%;
				}
				.right-icon {
					width: getsize(14px);
					height: getsize(26px);
				}
			}
			input {
				&::placeholder {
					/* Chrome, Firefox, Opera, Safari 10.1+ */
					color: #bcbcbc;
				}

				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: #bcbcbc;
				}

				&::-ms-input-placeholder {
					/* Microsoft Edge */
					color: #bcbcbc;
				}
			}
		}
		.upload-desc {
			padding-top: 0 !important;
			margin-bottom: getsize(22px);
			.h1 {
				display: flex;
				font-size: getsize(32px);
				color: #333333;
				padding: getsize(40px) 0 getsize(16px);
				font-weight: bold;
				span {
					color: #666666;
					font-size: getsize(28px);
					width: auto;
					font-weight: normal;
				}
			}
			p {
				font-size: getsize(28px);
				font-family: PingFangSC-Regular, PingFang SC;
				color: #666666;
				line-height: getsize(44px);
				span {
					display: inline-block;
					width: getsize(38px);
				}
			}
			.h-red {
				padding-top: getsize(37px);
				color: #f65e3e;
			}
		}
		.submit-btn {
			position: fixed;
			padding: 0 getsize(45px);
			width: 100%;
			box-sizing: border-box;
			bottom: getsize(77px);
			left: 0;
			z-index: 2;
			.btn {
				width: 100%;
				height: getsize(98px);
				border-radius: getsize(49px);
				font-size: getsize(36px);
				font-weight: bold;
				background: linear-gradient(270deg, #f55b44 0%, #fa7519 100%);
				box-shadow: 0px getsize(6px) getsize(36px) getsize(-16px) #f55b43;
				color: #ffffff;
				overflow: hidden;
				&.disabled {
					background: #ececec;
					color: #bcbcbc;
					box-shadow: none;
				}
			}
		}
	}
</style>
